import React from 'react';
import Text from './text';

const Subtitle = props => <Text fontWeight="normal" fontSize={2} color="gray.6" {...props} />;

export default Subtitle;
